import fly from '@/utils/http';
import uuid from 'uuid';

// 拉取医生历史智能小助手消息列表
export const getHistory = async (req = {}) => {
  const { aiMessages, err, total }: any = await fly.post('/assistant/getDoctorRecentlyMessage', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { aiMessages, total };
};

// 创建流式问答消息

const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
};

export const chatFetch = data => new Promise((resolve, reject) => {
  // 在原始数据中添加commonIn对象
  const requestData = {
    ...data,
    commonIn: {
      requestId: uuid(),
      client: 'doctor_web',
    },
  };

  fetch('/archive/interface/assistant/completions', {
    ...options,
    body: JSON.stringify(requestData),
  })
    .then(async (response) => {
      if (response.ok) {
        // 200-299 状态码
        resolve(response);
      } else {
        // 尝试解析错误信息（假设接口返回JSON格式的错误信息）
        const errorResponse = await response.json().catch(() => response.text());
        reject(errorResponse || 'Unknown error');
      }
    })
    .catch((error) => {
      // 处理网络错误或请求被阻止等异常
      reject(error);
      console.error('Fetch Error:', error);
    });
});

// 停止ai生成数据
export const stopGenerate = async (req = {}) => {
  const res: any = await fly.post('/assistant/stopCompletions', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 获取AIGPT医生默认Prompt文案列表
export const getPromptTemplates = async (req = {}) => {
  const { aiTemplateList, err, total }: any = await fly.post('/assistant/getPromptTemplates', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { aiTemplateList, total };
};

// 获取基于患者档案聊天的sessionId
export const getUserChatSessionId = async (req = {}) => {
  const res: any = await fly.post('/assistant/getUserChatSessionId', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};
